import React from 'react';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { Button } from 'antd';
import dayjs from 'dayjs';
import { ExportOutlined } from '@ant-design/icons';
import { IStockMatchingReportRes } from '@/interfaces/report';

interface IProps {
  data: IStockMatchingReportRes[];
}

const ExcelExport = ({ data }: IProps) => {
  const handleExport = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('StockMatchingReport');

    // Define header row
    const headers = [
      '#',
      'BUs',
      'ITEM NO',
      'ITEM NAME',
      'Kemin LotNumber',
      'Pioneer LotNumber',
      'Kemin Quantity',
      'Actual Quantity',
      'รอส่ง',
      'Diff',
    ];

    worksheet.getRow(1).values = headers;

    worksheet.getRow(1).eachCell(cell => {
      cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'c6251b' },
      };
      cell.alignment = { horizontal: 'center', vertical: 'middle' };
    });

    data.forEach((item, idx) => {
      const diff = Number(
        (item.keminQuantity || 0) - (item.pioneerQuantity || 0),
      );
      const row = worksheet.addRow([
        idx + 1,
        item.bUs,
        item.productCode,
        item.productName,
        item.keminLotNumber,
        item.lotNumber,
        item.keminQuantity,
        item.pioneerQuantity,
        item.pioneerReserveQuantity,
        diff,
      ]);

      if (diff !== 0) {
        const diffCell = row.getCell(10); // Column 10 = 'Diff'
        diffCell.fill = {
          type: 'pattern',
          pattern: 'solid',
          fgColor: { argb: diff < 0 ? 'FF7F7F' : '90EE90' }, // light red
        };
      }
    });

    // Auto width for columns
    worksheet.columns = headers.map((header, index) => ({
      header,
      key: `col${index}`,
      width: Math.max(header.length, 20) + 2, // Add padding
    }));

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    saveAs(blob, `stock-matching-report-${dayjs().format('YYYY-MM-DD')}.xlsx`);
  };

  return (
    <div>
      <Button type="primary" ghost onClick={handleExport}>
        <ExportOutlined /> Export to Excel
      </Button>
    </div>
  );
};

export default ExcelExport;
